import LanguageSwitch from '@/components/language-switch/LanguageSwitch'
import ProgressHeader from '@/components/progress/ProgressHeader'
import { AppContext } from '@/providers/app-provider'
import Image from 'next/image'
import logo from '../../../assets/img/stichting-open-logo.png'
import { use, ReactElement } from 'react'

const AppHeader = (): ReactElement => {
    const { areStepsVisible } = use(AppContext)

    return (
        <header className={`grid grid-cols-[1fr,auto,1fr] gap-x-6 items-center py-8 ${areStepsVisible ? 'mb-8' : ''}`}>
            <div className="flex justify-start">
                <Image src={logo} alt="Stichting Open" width="68" height="32" />
            </div>
            <div className="flex justify-center">{areStepsVisible && <ProgressHeader />}</div>
            <div className="flex justify-end" data-cy="language-switch">
                <LanguageSwitch />
            </div>
        </header>
    )
}

export default AppHeader
